export default __webpack_public_path__ + "static/media/PPI-firefeature-005.8ac63af0.jpg";